import { useTranslation } from 'react-i18next';
import { Badge } from '@unified-checkout/design-system';
import { Accordion } from 'libs/design-system/src/components/Accordion';
import styles from "./organizations-list.module.scss"

export const OrganizationsList = ({
    value,
    index
}: {
    value: any,
    index: number
}) => {
    const EMPTY_VALUE = '-';

    const { t } = useTranslation();

    return (
        <Accordion
            key={index}
            isOpen={true}
            header={
                <span className={styles["details-accordion__header"]}>
                    {t(`${value?.tenantName}`)}
                </span>
            }
            type="transparent_box"
            hasDivider
            alignment="center"
        >
            <div className={styles["details-accordion"]}>
                <span className={styles["details-accordion__item__key"]}>{t('innerLayout.xeroPage.organizationsList.tenantId')}</span>
                <span className={styles["details-accordion__item__value"]}>: {value?.tenantId || EMPTY_VALUE}</span>
            </div>

            <div className={styles["details-accordion"]}>
                <span className={styles["details-accordion__item__key"]}>{t('innerLayout.xeroPage.organizationsList.organizationName')}</span>
                <span className={styles["details-accordion__item__value"]}>: {value?.tenantName || EMPTY_VALUE}</span>
            </div>

            <div className={styles["details-accordion"]}>
                <span className={styles["details-accordion__item__key"]}>{t('innerLayout.xeroPage.organizationsList.status')}</span>
                <span className={styles["details-accordion__badge"]}>
                    : <Badge text={t('innerLayout.xeroPage.organizationsList.connected')} color="green" size="sm" />
                </span>
            </div>

        </Accordion>
    );
}
